<template>
<div>



<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">
<div class="mt-4">

<div class="grid">
<div class="col-12 md:col-8">
 <div class="grid">

<!-- started-->
<div class="col-6 md:col-2" v-if="started>0">
<p class="text-primary"><b>{{$store.state.languages.lang_phrases.baslandi}}:</b></p>
</div>

<div class="col-6 md:col-10" v-if="started>0">
<p>{{started}}</p>
</div>
<!-- started-->

<!-- created-->
<div class="col-6 md:col-2" v-if="created>0">
<p class="text-primary"><b>{{$store.state.languages.lang_phrases.olusturuldu}}:</b></p>
</div>

<div class="col-6 md:col-10" v-if="created>0">
<p>{{created}}</p>
</div>
<!-- created-->

<!-- viewed-->
<div class="col-6 md:col-2" v-if="viewed>0">
<p class="text-primary"><b>{{$store.state.languages.lang_phrases.goruntulendi}}:</b></p>
</div>

<div class="col-6 md:col-10" v-if="viewed>0">
<p>{{viewed}}</p>
</div>
<!-- viewed-->

<!-- finished-->
<div class="col-6 md:col-2" v-if="finished>0">
<p class="text-primary"><b>{{$store.state.languages.lang_phrases.tamamlandi0}}:</b></p>
</div>

<div class="col-6 md:col-10" v-if="finished>0">
<p>{{finished}}</p>
</div>
<!-- finished-->

<!-- under_review-->
<div class="col-6 md:col-2" v-if="under_review>0">
<p class="text-primary"><b>{{$store.state.languages.lang_phrases.degerlendirmede}}:</b></p>
</div>

<div class="col-6 md:col-10" v-if="under_review>0">
<p>{{under_review}}</p>
</div>
<!-- under_review-->

<!-- canceled-->
<div class="col-6 md:col-2" v-if="canceled>0">
<p class="text-primary"><b>{{$store.state.languages.lang_phrases.iptal_edildi}}:</b></p>
</div>

<div class="col-6 md:col-10" v-if="canceled>0">
<p>{{canceled}}</p>
</div>
<!-- canceled-->

<!-- correction_requested-->
<div class="col-6 md:col-2" v-if="correction_requested>0">
<p class="text-primary"><b>{{$store.state.languages.lang_phrases.duzeltme_talebi_incelemede}}:</b></p>
</div>

<div class="col-6 md:col-10" v-if="correction_requested>0">
<p>{{correction_requested}}</p>
</div>
<!-- correction_requested-->


</div>

</div>


<!-- chart-->
<div class="col-12 md:col-3">
<Chart type="doughnut" :data="chartData" :options="lightOptions" />
</div>
<!-- chart-->
</div>




</div>
</template>



</div>
</template>

<script>
export default {

  name: 'FlowStatus',

  data () {
    return {
      created:0,
      viewed:0,
      started:0,
      finished:0,
      under_review:0,
      canceled:0,
      correction_requested:0,
      loading:true,
      chartData: {
          labels: [],
          datasets: [
              {
                  data: [],
                  backgroundColor: [],
              }
          ]
      },
      lightOptions: {
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        }
      }
    }
  },
  mounted()
  {
    this.$store.dispatch('ui/setActiveTab',"durum")
    this.getData()
  },
  computed:
  {
    preflang_id()
    {
      return this.$store.state.auth.user.preflang_id
    }
  },
  watch:{
    preflang_id(newVal,oldVal)
    {
      setTimeout(()=>{
        this.getData()
      },100)
      
    }
  },
  methods:{
    async getData()
    {
      this.loading = await true
      this.chartData.labels = []
      this.chartData.datasets[0].data = []
      let suppliers = await this.generalApiGetWithoutLoader("flow/all_suppliers/"+this.$route.params.id)
      //let suppliers = await this.$store.state.flows.suppliers
      await console.log(suppliers)
      for(let item of suppliers)
      {
        let status = item.status

        this[status]++
      }

      if(this.started>0)
      {
        this.chartData.labels.push(this.$store.state.languages.lang_phrases.baslandi)
        this.chartData.datasets[0].data.push(this.started)
        this.chartData.datasets[0].backgroundColor.push("#dd4b39")
      }

      if(this.created>0)
      {
        this.chartData.labels.push(this.$store.state.languages.lang_phrases.olusturuldu)
        this.chartData.datasets[0].data.push(this.created)
        this.chartData.datasets[0].backgroundColor.push("#352f8d")
      }

      if(this.viewed>0)
      {
        this.chartData.labels.push(this.$store.state.languages.lang_phrases.goruntulendi)
        this.chartData.datasets[0].data.push(this.viewed)
        this.chartData.datasets[0].backgroundColor.push("#7e2f8d")
      }

      if(this.finished>0)
      {
        console.log(this.finished)
        console.log(this.chartData.datasets)
        this.chartData.labels.push(this.$store.state.languages.lang_phrases.tamamlandi0)
        this.chartData.datasets[0].data.push(this.finished)
        this.chartData.datasets[0].backgroundColor.push("#4dc247")
      }

      if(this.under_review>0)
      {
        this.chartData.labels.push(this.$store.state.languages.lang_phrases.degerlendirmede)
        this.chartData.datasets[0].data.push(this.under_review)
        this.chartData.datasets[0].backgroundColor.push("#ff6600")
      }

      if(this.canceled>0)
      {
        this.chartData.labels.push(this.$store.state.languages.lang_phrases.iptal_edildi)
        this.chartData.datasets[0].data.push(this.canceled)
        this.chartData.datasets[0].backgroundColor.push("#a82400")
      }

      if(this.correction_requested>0)
      {
        this.chartData.labels.push(this.$store.state.languages.lang_phrases.duzeltme_talebi_incelemede)
        this.chartData.datasets[0].data.push(this.correction_requested)
        this.chartData.datasets[0].backgroundColor.push("#3b82f6")
      }

      this.loading = await false



    },
  }
}
</script>

<style lang="css" scoped>
</style>